import { render, staticRenderFns } from "./gitea.vue?vue&type=template&id=6ebceb3a&scoped=true"
import script from "./gitea.vue?vue&type=script&lang=js"
export * from "./gitea.vue?vue&type=script&lang=js"
import style0 from "./gitea.vue?vue&type=style&index=0&id=6ebceb3a&prod&lang=less&scoped=true"
import style1 from "./gitea.vue?vue&type=style&index=1&id=6ebceb3a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebceb3a",
  null
  
)

export default component.exports